import { Toast } from "react-vant";
import i18n from '@/i18n';
/**
 * 不四舍五入的固定小数位数
 * @param num 数值
 * @param decimals 小数位数
 * @param autoFill 是否自动填充0
 * @returns 固定小数位数的字符串
 */
export function toFixedNoRound(
    num: number | string | undefined | null,
    decimals: number = 2,
    autoFill: boolean = true
): string {
    if (typeof num === "undefined" || num === null) {
        return "0." + "0".repeat(decimals);
    }

    // 将数值转换为字符串，避免精度丢失
    let str = num.toString();

    // 找到小数点的位置
    const decimalIndex = str.indexOf(".");

    if (decimalIndex === -1) {
        // 没有小数点
        if (autoFill && decimals > 0) {
            return str + "." + "0".repeat(decimals);
        }
        return str;
    }

    // 如果小数点后数字不足要求的小数位数，则补充0
    const integerPart = str.slice(0, decimalIndex);
    let decimalPart = str.slice(decimalIndex + 1, decimalIndex + decimals + 1);

    if (decimalPart.length < decimals && autoFill) {
        decimalPart = decimalPart.padEnd(decimals, "0");
    }

    return decimals > 0 ? integerPart + "." + decimalPart : integerPart;
}


/**
 * 计算距离指定时间戳还有多少分钟
 * @param timestamp 时间戳（可以是秒级或毫秒级）
 * @returns 距离该时间戳的分钟数，正数表示未来时间，负数表示过去时间
 */
export function getMinutesToTimestamp(timestamp: number): number {
    // 如果传入的时间戳为空或无效，返回0
    if (!timestamp) {
        return 0;
    }
    // 获取当前时间戳（毫秒）
    const now = Date.now();

    // 判断传入的时间戳是秒级还是毫秒级
    // 如果时间戳小于等于10位数字，认为是秒级时间戳
    const targetTimestamp = timestamp.toString().length <= 10
        ? timestamp * 1000  // 秒级转毫秒级
        : timestamp;        // 已经是毫秒级

    // 计算时间差（毫秒）
    const timeDiff = targetTimestamp - now;

    // 转换为分钟数（返回整数）
    const minutes = Math.round(timeDiff / (1000 * 60));

    return minutes;
}

//
export const copyToClipboard = async (text: string) => {
    if (!text) return;
    let isCopied = false;
    // 优先使用现代化的 clipboard API
    if (navigator.clipboard) {
        try {
            await navigator.clipboard.writeText(text);
            Toast.success(i18n.t('已复制到剪贴板'));
            isCopied = true;
        } catch (err) {
            console.error("Modern clipboard API failed, falling back to execCommand", err);
        }
    }

    // 如果现代化 API 失败，尝试使用 document.execCommand('copy')
    if (!isCopied) {
        try {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed";
            textArea.style.display = "none";
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("copy");
            console.log("Text copied using execCommand and textarea");
            Toast.success(i18n.t('已复制到剪贴板'));
            document.body.removeChild(textArea);
            isCopied = true;
        } catch (err) {
            console.warn("execCommand with textarea failed: ", err);
        }
    }

    // 如果 execCommand 失败，尝试使用 selection 和 range
    if (!isCopied) {
        try {
            const selection = window.getSelection();
            if (!selection) {
                throw new Error("Failed to get selection");
            }
            const range = document.createRange();
            const tempDiv = document.createElement('div');
            tempDiv.textContent = text;
            document.body.appendChild(tempDiv);
            range.selectNodeContents(tempDiv);
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand('copy');
            console.log("Text copied using execCommand and selection");
            Toast.success(i18n.t('已复制到剪贴板'));
            isCopied = true;
            selection.removeAllRanges();
            document.body.removeChild(tempDiv);
        } catch (err) {
            console.warn("execCommand with selection failed: ", err);
            Toast.fail(i18n.t('复制失败'));
        }
    }
}

